import Image from 'components/image';
import {Link} from 'gatsby';
import React from 'react';
import Style from 'styles/components/footer.module.scss';

const Footer = () => {
  return (
    <footer>
      <div className={Style.ftInner}>
        <div className={Style.ftCompany}>
          <div className={Style.ftCompany__logos}>
            <Link className={Style.ftCompany__logo} to="/">
              <Image className={Style.ftCompany__logoImg} filename="logo_eize.png" alt="e-ize" />
            </Link>
            <a className={Style.ftCompany__comachi} href="https://www.comachicart.jp/" target="_blank" rel="noopener noreferrer">
              <Image filename="comachi_banner.png" alt="comachi cart -コマチカート-" />
            </a>
          </div>
          <p className={Style.ftCompany__address}>
            株式会社イーゼ<br />
            〒101-0052<br />
            東京都千代田区神田小川町3-6-1<br />
            栄信ビル7階
          </p>
        </div>
        <div className={Style.ftNav}>
          <div className={Style.ftNav__title}>Navigation</div>
          <ul className={Style.ftNav__list}>
            <li><Link className={Style.ftNav__link} to="/service/">Service</Link></li>
            <li><Link className={Style.ftNav__link} to="/about/">About</Link></li>
            <li><Link className={Style.ftNav__link} to="/recruit/">Recruit</Link></li>
            <li><Link className={Style.ftNav__link} to="/contact/">Contact</Link></li>
            <li><Link className={Style.ftNav__link} to="/privacy/">Privacy Policy</Link></li>
          </ul>
        </div>
        <div className={Style.ftContact}>
          <div className={Style.ftNav__title}>Get in touch</div>
          <Link className={Style.ftContact__btn} to="/recruit/">
            ENTRY
            <span className={Style.ftContact__arrow}>＞</span>
          </Link>
          <Link className={Style.ftContact__btn} to="/contact/">
            CONTACT
            <span className={Style.ftContact__arrow}>＞</span>
          </Link>
        </div>
      </div>
      <div className={Style.ftBottom}>
        <span className={Style.ftBottom__copyright}>Copyright© e-ize Co.Ltd. All Rights Reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;
